<template>
  <Modal ref="modal" class="modal-user-lock" :actions="actions" @action="handleAction" immediate>
    <h1>Benutzer {{ $t(`user.locked.${locked}`) }}</h1>
    <p>Wollen Sie den Benutzer wirklich {{ $t(`user.locked.${locked}`) }}?</p>
    <div class="info" v-if="inquiries > 0">
      <Icon name="info" />
      Dieser Benutzer hat noch Fälle zugewiesen.
    </div>
  </Modal>
</template>

<script>
  import Modal from '@/components/ui/Modal';
  import Select from '@/components/ui/inputs/Select';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'ModalUserLock',
    components: {
      Icon,
      Select,
      Modal,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      uuid: {
        type: String,
        default: null,
      },
      locked: {
        type: Boolean,
        default: false,
      },
      inquiries: {
        type: Number,
        default: 0,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      actions() {
        const i18n = this.$i18n;
        const out = [
          { value: 'cancel', label: i18n.t('labels.cancel') },
        ];
        if (!this.locked) {
          out.push({ value: 'toggle', label: i18n.t('labels.lock') });
        } else {
          out.push({ value: 'toggle', label: i18n.t('labels.unlock') });
        }
        return out;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // async created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      async handleAction(action) {
        if (action === 'toggle') {
          const uuid = this.uuid;
          const response = await this.$sav.api.post(`/user/${uuid}/lock`);
          if (response) {
            this.$emit('done');
          }
        }
        this.$refs.modal.close();
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.modal-user-lock {
  h1 {
    margin-bottom: 12px;
  }

  p {
    @include font-body-medium;
    color: $color-black-solid-100;
  }

  div.info {
    position: relative;
    padding: 8px 8px 8px 42px;
    border: 1px solid $color-blue-solid-100;
    border-radius: 4px;
    box-shadow: $box-shadow-1;
    color: $color-blue-solid-100;
    svg {
      top: 50%;
      left: 8px;
      transform: translate(0, -50%);
      position: absolute;
      width: 20px;
      height: 20px;
    }
  }

  form {
    padding: 24px 0;

    .group {
      margin-bottom: 24px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }

    hr {
      border: 0;
      margin: 24px 0;
      border-bottom: 1px solid $color-black-alpha-10;
    }
  }
}
</style>
